///style
import "./creditScoreArcRes.css";
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";
import * as urls from "../../urls"; ///utils/urls
import { getCookie } from "../../utils/common";
import axios from "axios";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";

function creditScoreArcRes(props) {

  // * Cookies
  const [cookies, setCookie] = useCookies(["user"]);
  // console.log(cookies);
  const contact_id = getCookie("contactID");
  const access_token = getCookie("tokenForCustomers");
  // console.log(access_token, "tokenForCustomers");
  // console.log("props?.ContactId",props?.ContactId)

  const [buroScore, setBuroScore] = useState(null);
  // console.log("buroScore",buroScore)
  props.setBuroScoreP(buroScore);
  const headersCommonNew = {
    domain_name: "yoindi",
    Authorization: `Bearer ${access_token || ""}`,
    "Content-Type": "application/json",
  };
  
  const pullBureauData = () => {
    // setIsLoader(true);

    let bodyData = {
      contact_id: props?.ContactId,
    };
    var config7 = {
      method: "post",
      url: `${process.env.REACT_APP_API_BASE_URL}${urls.CREDIT_DETAILS}`,
      headers: headersCommonNew,
      data: bodyData,
    };

    axios(config7)
      .then(function (response) {
        // props?.getDetails(true);
        // console.log("Inside Then :", response?.data);
        const _score = response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]
        setBuroScore(
          typeof _score === 'undefined' ? null : _score
        );
        const crifstatuss = response?.data?.msg;
        // console.log("crifStatus", crifstatuss);
        setCrifStatus(crifstatuss);
        
        // setIsLoader(false);
        if (response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]) {
          setBuroScore(
            response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]
          );

          setCreditScore(
            response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]
          );
          let personalLoanCount = [];
          let creditLoanCount = [];
          let homeLoanCount = [];
          let autoLoanCount = [];
          let otherLoanCount = [];
          let totalBalance = 0;
          let totalDisbursedCount = 0;
          let personalLoanBalanceCount = 0;
          let personalLoanDisbursedCount = 0;
          let creditLoanBalanceCount = 0;
          let creditLoanDisbursedCount = 0;
          let homeLoanBalanceCount = 0;
          let homeLoanDisbursedCount = 0;
          let autoLoanBalanceCount = 0;
          let autoLoanDisbursedCount = 0;
          let otherLoanBalanceCount = 0;
          let otherLoanDisbursedCount = 0;

          response?.data?.["B2C-REPORT"]?.RESPONSES?.map((item) => {
            // console.log("Start If");

            if (
              item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCOUNT-STATUS"] === "Active"
            ) {
              // console.log("Inside If");
              totalBalance =
                parseInt(
                  item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                    /,/g,
                    ""
                  )
                ) + totalBalance;
              totalDisbursedCount =
                parseInt(
                  item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                    /,/g,
                    ""
                  )
                ) + totalDisbursedCount;
              // console.log("Upper Personal Loan");
              if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] ===
                "Personal Loan"
              ) {
                // console.log("Inside Personal Loan");
                personalLoanCount.push(0);
                personalLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"]?.replace(
                      /,/g,
                      ""
                    )
                  ) + personalLoanBalanceCount;
                personalLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.[
                      "DISBURSED-AMT"
                    ]?.replace(/,/g, "")
                  ) + personalLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] ===
                "Credit Card"
              ) {
                creditLoanCount.push(0);
                creditLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + creditLoanBalanceCount;
                creditLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + creditLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] === "Home Loan"
              ) {
                homeLoanCount.push(0);
                homeLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + homeLoanBalanceCount;
                homeLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + homeLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"]?.includes(
                  "Wheeler"
                )
              ) {
                autoLoanCount.push(0);
                autoLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + autoLoanBalanceCount;
                autoLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + autoLoanDisbursedCount;
              } else {
                otherLoanCount.push(0);
                otherLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + otherLoanBalanceCount;
                otherLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + otherLoanDisbursedCount;
              }
            }
            // console.log("Line no 243");
          });
          // console.log("this is before totalBalancePer");
          let totalBalancePer = 0;
          if (totalBalance > 0 && totalDisbursedCount > 0) {
            totalBalancePer = (
              (totalBalance / totalDisbursedCount) *
              100
            ).toFixed(2);
          }

          let personalLoanPer = 0;
          if (personalLoanBalanceCount > 0 && personalLoanDisbursedCount > 0) {
            personalLoanPer = (
              (personalLoanBalanceCount / personalLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          let creditLoanPer = 0;
          if (creditLoanBalanceCount > 0 && creditLoanDisbursedCount > 0) {
            creditLoanPer = (
              (creditLoanBalanceCount / creditLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          let homeLoanPer = 0;
          if (homeLoanBalanceCount > 0 && homeLoanBalanceCount > 0) {
            homeLoanPer = (
              (homeLoanBalanceCount / homeLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          let autoLoanPer = 0;
          if (autoLoanBalanceCount > 0 && autoLoanDisbursedCount > 0) {
            autoLoanPer = (
              (autoLoanBalanceCount / autoLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          let otherLoanPer = 0;
          if (otherLoanBalanceCount > 0 && otherLoanDisbursedCount > 0) {
            otherLoanPer = (
              (otherLoanBalanceCount / otherLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          // console.log("this is before setLoanDetails");

          setLoanDetails({
            ...loanDetails,
            personalLoan: personalLoanCount?.length,
            creditLoans: creditLoanCount?.length,
            otherLoans: otherLoanCount?.length,
            homeLoan: homeLoanCount?.length,
            autoLoans: autoLoanCount?.length,
            totalAmountPercentage: totalBalancePer,
            personalLoanAmountPer: personalLoanPer,
            homeLoanAmountPer: homeLoanPer,
            creditLoanAmountPer: creditLoanPer,
            autoLoanAmountPer: autoLoanPer,
            otherLoanAmountPer: otherLoanPer,
            totalDisbursedCount: numDifferentiation(totalDisbursedCount),
            totalPersonalLoanDisbursedCount: numDifferentiation(
              personalLoanDisbursedCount
            ),
            totalCreditLoanDisbursedCount: numDifferentiation(
              creditLoanDisbursedCount
            ),
            totalOtherLoanDisbursedCount: numDifferentiation(
              otherLoanDisbursedCount
            ),
            totalHomeLoanDisbursedCount: numDifferentiation(
              homeLoanDisbursedCount
            ),
            totalAutoLoanDisbursedCount: numDifferentiation(
              autoLoanDisbursedCount
            ),
            totalBalance: numDifferentiation(totalBalance),
            personalLoanBalance: numDifferentiation(personalLoanBalanceCount),
            creditLoanBalance: numDifferentiation(creditLoanBalanceCount),
            otherLoanBalance: numDifferentiation(otherLoanBalanceCount),
            homeLoanBalance: numDifferentiation(homeLoanBalanceCount),
            autoLoanBalance: numDifferentiation(autoLoanBalanceCount),
            total:
              personalLoanCount?.length +
              creditLoanCount?.length +
              otherLoanCount?.length +
              homeLoanCount?.length +
              autoLoanCount?.length,
            //  response?.data?.data?.["B2C-REPORT"]?.RESPONSES?.length
          });
        } else {
          toast.warning(response?.data?.msg);
        }
        // console.log("Inside Then End");
      })
      .catch(function (err) {
        // console.log("err.response : ", err.response);
        // alert(err.response.data.message);
      });
  };
  
    const score = props.creditScore != null ? props.creditScore : buroScore; // Replace this with your actual score value
    //const score = buroScore !== null ? buroScore : props.creditScore;
    // console.log("score:",score);
    const minScore = 300;
    const maxScore = 900;
  
    // Normalize the score between 0 and 100
    const normalizedScore = ((score - minScore) / (maxScore - minScore)) * 100;
  
    return (
      <div className="score-wrap">
        
        <div className="score">
        
            {/* <div className="refesh"> */}
            <Tooltip className="refesh" title="Pull Bureau Score">
          <RefreshIcon
            onClick={() => {
              pullBureauData();
            }}
            variant="contained"
            style={{
              // position: "relative",
              // top: "-62px",
              // left: "134px",
              color: "#0a2472",
              cursor: "pointer",
            }}
          />
        </Tooltip>
        
        {/* </div> */}
        
            <div className="leftNum">300</div>
            <div className = "status" id="currentScoreDetail">
              <b>
              {
              score === null? "CRIF details does not exist" :
              score < 600
                  ? "Poor"
                  : score >= 600 && score < 750
                  ? "Fair"
                  : score >= 750 && score < 800
                  ? "Good"
                  : score >= 800
                  ? "Excellent"
                  : ""}
              </b>    
            </div>
            <div className="rightNum">900</div>
          <div className="score-bar">
            <div className="">{progressBar(100)}</div>
            <div className="score-circle">{progressBar(normalizedScore, true)}</div>
          </div>
          <div className="score-value">
            <div className="score-name">Score</div>
            <div className="score-number">{Math.round(score)}</div>
          </div>
        </div>
      </div>
    );
  }
  
  function progressBar(score, gradient = false) {
    // Ensure the score is within the range of 0 to 100
    const normalizedScore = Math.min(Math.max(score, 0), 100);
  
    const radius = 85;
    const dashArray = (Math.PI * radius * normalizedScore) / 100;
  
    return (
      <svg width="195" height="120">
        <circle
          cx="100"
          cy="100"
          r={radius}
          fill="none"
          strokeWidth="10"
          strokeLinecap="round"
          strokeDashoffset={-1 * Math.PI * radius}
          strokeDasharray={`${dashArray} 10000`}
          stroke={gradient ? "url(#score-gradient)" : "#e5e5e5"}
        ></circle>
        {gradient && (
          <defs>
            <linearGradient id="score-gradient">
              <stop offset="0%" stopColor="red" />
              <stop offset="25%" stopColor="orange" />
              <stop offset="100%" stopColor="green" />
            </linearGradient>
          </defs>
        )}
      </svg>
    );
  }
  
//   ReactDOM.render(<creditScoreArcRes />, document.getElementById("creditScoreArcRes"));
export default creditScoreArcRes;  
  